import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {BsFillCaretRightFill, BsFillCaretDownFill} from "react-icons/bs";
import withBreadcrumbs from "react-router-breadcrumbs-hoc";


const TreeNode = ({node, children, firstItem, breadcrumbs}) => {
    const route = useLocation();
    const newRoute = route.pathname === "/" ? "" : route.pathname;
    const [isVisible, setIsVisible] = useState(false);
    const toggle = () => {
        setIsVisible(!isVisible);
    };

    let span = isVisible ?  <BsFillCaretDownFill/> : <BsFillCaretRightFill/>;

    const checkRoute = (name) => {
        if (firstItem) {
            return `/arhiva/${name}`;
        }
        else if(newRoute.indexOf(name) > -1) {
            return newRoute;
        }
        else {
            return  `${newRoute}/${name}`;
        }
    };

    const checkBreadcrumb = (name, breadcrumbs) => {
        if (breadcrumbs?.filter(({match}) => match.url.indexOf(name) > -1).length) {
            return breadcrumbs?.filter(({match}) => match.url.indexOf(name) > -1)[0].key;
        }
        else {
            return `/${name}`;
        }
    };

    return (
            <li key={node.name}>
                {children && (
                    <Link to={isVisible ? checkBreadcrumb(node.name, breadcrumbs) : checkRoute(node.name)} onClick={() => toggle(node.name)}>{span}</Link>
                )}
                {node.name}
                <ul>{isVisible && (children?.map((i) =><TreeNode node={i} children={i.children} firstItem={false} breadcrumbs={breadcrumbs}/>))
                }</ul>
            </li>
    )
};

export default withBreadcrumbs()(TreeNode);